<template>
    <div>
        <nav-bar></nav-bar>

        <div class="container">

            <div class="section">

                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a @click="$router.back()">Chatbots</a></li>
                        <li class="is-active"><a href="#" aria-current="page">Editar Cliente</a></li>
                    </ul>
                </nav>

                <div class="field">
                    <label class="label">Nombre</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Nombre del cliente" v-model="client.name">
                    </div>
                </div>

                <div class="field">
                    <label class="label">Descripción</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Descripción" maxlength="50" v-model="client.description">
                    </div>
                </div>

                <br>

                <div class="button is-primary is-left" @click="updateClient">
                    <span class="icon"><i class="fas fa-save fa-lg"></i></span>
                    <span class="is-capitalized">Guardar</span>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
export default {
  data () {
    return {
      client: {idClient: null, name: null, description: null}
    }
  },
  mounted () {
    this.api.post('/ClientById/', {idClient: this.$route.params.client}).then(response => {
      this.client = response.client
    })
  },
  methods: {
    updateClient () {
      this.api.post('/ClientUpdate', this.client).then(() => {
        this.$router.push('/clients')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/clients/UpdateClient.vue